export const environment = {
  production: false,
  apiUrl: 'https://dev-gmg.m.com.mx/api',
};
